import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithubSquare } from "@fortawesome/free-brands-svg-icons";
import "../../styles/pages/socials.scss";

const FooterBar = () => {
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center">
        <a href="https://github.com/zuma990" target="_blank" rel="noreferrer" alt="social" >
          <FontAwesomeIcon className="social" icon={faGithubSquare} />
          <span className="social-box">Adis</span>
        </a>
        <a href="https://github.com/Zaraneven" target="_blank" rel="noreferrer" alt="social">
          <FontAwesomeIcon className="social" icon={faGithubSquare} />
          <span className="social-box">Neven</span>
        </a>
        <a href="https://github.com/DedicE" target="_blank" rel="noreferrer" alt="social">
          <FontAwesomeIcon className="social" icon={faGithubSquare} />
          <span className="social-box">Emir</span>
        </a>
        <a href="https://github.com/shile88" target="_blank" rel="noreferrer" alt="social">
          <FontAwesomeIcon className="social" icon={faGithubSquare} />
          <span className="social-box">Milos</span>
        </a>
        <a href="https://github.com/gorazd007" target="_blank" rel="noreferrer" alt="social">
          <FontAwesomeIcon className="social" icon={faGithubSquare} />
          <span className="social-box">Gorazd</span>
        </a>
      </div>
      <div className="social-box">
        <p className="mb-1">Created by Team Alfa</p>
      </div>

    </div>
  );
};

export default FooterBar;
